import React from 'react';

const T = {
  live: 'text-live bg-live-soft border-live/25', caution: 'text-caution bg-caution-soft border-caution/25',
  signal: 'text-signal bg-signal-soft border-signal/30', neutral: 'text-fg-dim bg-raised border-line',
  info: 'text-fg bg-raised border-fg/15',
};
const CONFIGS = {
  severity: { low: ['Bajo', 'live'], medium: ['Medio', 'caution'], high: ['Alto', 'signal', true], default: ['Sin gravedad', 'neutral'] },
  type: { bug: ['Bug', 'signal'], improvement: ['Mejora', 'info'], default: ['Sin tipo', 'neutral'] },
  status: { open: ['Abierto', 'info', true], closed: ['Cerrado', 'neutral'], default: ['Sin estado', 'neutral'] },
};

const Badge = ({ type, value, pulse }) => {
  const map = CONFIGS[type];
  if (!map) return null;
  const [text, tone, dot] = map[value] || map.default;
  return (
    <span className={`inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full border text-[12px] font-semibold whitespace-nowrap ${T[tone]}`}>
      {(pulse || dot) && <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" aria-hidden />}
      {text}
    </span>
  );
};

export default Badge;
